import { Directive, ElementRef, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import * as cytoscape from 'cytoscape';

@Directive({
  // tslint:disable-next-line:directive-selector
  selector: '[ngFlowDesignerEdgeController]',
})
export class NgFlowDesignerEdgeControllerDirective implements OnChanges, OnInit {
  @Input()
  public edgeHighLightColor: string;

  @Input()
  public target: string;

  @Input()
  public id: string;

  @Input()
  public removeEdgeOnClick = false;

  @Output()
  public mouseOverEdge = new EventEmitter<any>();

  @Output()
  public mouseOutEdge = new EventEmitter<any>();

  @Output()
  public clickEdge = new EventEmitter<any>();

  private cy;

  public edgePath: SVGElement;

  constructor(public host: ElementRef) {}

  public ngOnChanges(changes: SimpleChanges): void {
    this.target = changes.target.currentValue;
  }

  public registerListeners(): void {
    setTimeout(() => {
      if (!this.edgePath) {
        return;
      }
      this.edgePath.addEventListener('mouseover', e => {
        this.mouseOverEdge.emit(e);
      });

      this.edgePath.addEventListener('mouseout', e => {
        this.mouseOutEdge.emit(e);
      });

      this.edgePath.addEventListener('click', e => {
        this.clickEdge.emit(e);
      });
    }, 500);
  }

  public registerCy(cy: cytoscape.Core) {
    this.cy = cy;
  }

  public ngOnInit(): void {
    this.registerListeners();
  }
}
